var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2881,
    cy: 11.8821,
    r: 11.3821,
    fill: "#FAF0E1",
    stroke: "#DEB374"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9762 16.182C9.74016 16.182 8.42716 15.077 8.42716 13.452C8.42716 13.075 8.49216 12.685 8.62216 12.282L9.63616 12.607C9.57116 12.815 9.53216 13.075 9.53216 13.4C9.53216 14.531 10.5202 15.207 12.0282 15.207C13.4192 15.207 14.2772 14.596 14.2772 13.608C14.2772 12.841 13.7052 12.347 12.5742 12.1L11.3652 11.84C9.45416 11.424 8.72616 10.605 8.72616 9.305C8.72616 8.538 9.01216 7.927 9.59716 7.472C10.1822 7.017 10.8972 6.783 11.7552 6.783C13.9262 6.783 15.1352 7.875 15.2782 9.838L14.1732 9.994C13.9782 8.499 13.1722 7.758 11.7422 7.758C10.5852 7.758 9.83116 8.317 9.83116 9.266C9.83116 10.033 10.4552 10.54 11.6902 10.813L12.8732 11.06C14.6542 11.437 15.3822 12.269 15.3822 13.53C15.3822 14.362 15.0572 15.012 14.4072 15.48C13.7572 15.948 12.9512 16.182 11.9762 16.182Z",
    fill: "#D7A459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterS);
export default __webpack_public_path__ + "static/media/letterS.18011eb66f35c315a0a6783830122aec.svg";
export { ForwardRef as ReactComponent };